// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2cMI4","rightAdornment":"Header_rightAdornment__10z_r"};